module.exports = __webpack_public_path__ + "img/background.49017b49.jpeg";